/**
 * 📊 V208.0: PostHog Event Name Constants
 * 
 * Type-safe event names for consistent analytics tracking.
 * All event names should be defined here to prevent typos and ensure consistency.
 */

export const AnalyticsEvents = {
  // User Lifecycle
  USER_SIGNED_UP: 'user_signed_up',
  USER_SIGNED_IN: 'user_signed_in',
  USER_SIGNED_OUT: 'user_signed_out',
  USER_IDENTIFIED: 'user_identified',
  
  // Onboarding
  ONBOARDING_STARTED: 'onboarding_started',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
  ONBOARDING_ABANDONED: 'onboarding_abandoned',
  
  // Profile
  PROFILE_VIEWED: 'profile_viewed',
  PROFILE_EDITED: 'profile_edited',
  PROFILE_PHOTO_UPLOADED: 'profile_photo_uploaded',
  PROFILE_COMPLETED: 'profile_completed',
  
  // Network & Connections
  CONNECTION_REQUEST_SENT: 'connection_request_sent',
  CONNECTION_REQUEST_ACCEPTED: 'connection_request_accepted',
  CONNECTION_REQUEST_DECLINED: 'connection_request_declined',
  CONNECTION_REMOVED: 'connection_removed',
  NETWORK_VIEWED: 'network_viewed',
  
  // Discover
  DISCOVER_VIEWED: 'discover_viewed',
  DISCOVER_PROFILE_VIEWED: 'discover_profile_viewed',
  DISCOVER_SEARCH_PERFORMED: 'discover_search_performed',
  DISCOVER_FILTER_APPLIED: 'discover_filter_applied',
  
  // Messaging
  MESSAGE_SENT: 'message_sent',
  MESSAGE_READ: 'message_read',
  CHAT_OPENED: 'chat_opened',
  CHAT_CLOSED: 'chat_closed',
  
  // Subscription & Billing
  SUBSCRIPTION_VIEWED: 'subscription_viewed',
  SUBSCRIPTION_STARTED: 'subscription_started',
  SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
  SUBSCRIPTION_RENEWED: 'subscription_renewed',
  PAYMENT_INITIATED: 'payment_initiated',
  PAYMENT_COMPLETED: 'payment_completed',
  PAYMENT_FAILED: 'payment_failed',
  
  // Feature Usage
  FEATURE_USED: 'feature_used',
  SETTINGS_VIEWED: 'settings_viewed',
  SETTINGS_CHANGED: 'settings_changed',
  
  // Errors & Performance
  ERROR_OCCURRED: 'error_occurred',
  PERFORMANCE_METRIC: 'performance_metric',
  
  // Engagement
  PAGE_VIEWED: 'page_viewed',
  BUTTON_CLICKED: 'button_clicked',
  LINK_CLICKED: 'link_clicked',
  
  // Invites (existing)
  INVITE_SENT: 'invite_sent',
  INVITE_ACCEPTED: 'invite_accepted',
  
  // Test Events
  TEST_EVENT: 'test_event',

  // V208.0 Hardening: Minimal production events
  APP_OPENED: 'app_opened',
  SCREEN_VIEWED: 'screen_viewed',
  PAYWALL_VIEWED: 'paywall_viewed',
  SUBSCRIBE_CLICKED: 'subscribe_clicked',
  PURCHASE_SUCCEEDED: 'purchase_succeeded',
  PURCHASE_FAILED: 'purchase_failed',
} as const;

/** V208.0: Hardcoded screen names — never derive from URL/route */
export type ScreenName = 'Discover' | 'Network' | 'Profile' | 'Chat' | 'Settings';

export type AnalyticsEventName = typeof AnalyticsEvents[keyof typeof AnalyticsEvents];
